import { css } from "styled-components";

/**
 * Brand values shared by every Present Mode surface (dialog, big screen, phone remote), from
 * the "Stage Mode" page of the design canvas. Change them here, not per component.
 */
export const PRESENT_COLORS = {
    heading: "#2D4B7C",
    body: "#1F2A44",
    muted: "#5A6478",
    secondary: "#4A5568",
    faint: "#8A93A6",
    surface: "#F5F6F8",
    /** Card outlines in the dialog. */
    border: "#D5D9E2",
    /** Card outlines on the phone and the big screen's waiting card. */
    cardBorder: "#E1E4EC",
    divider: "#EEF0F4",
    accent: "#4F5BD5",
    accentHover: "#3B45B0",
    tint: "#E6E8FA",
    outline: "#C9CEF0",
    success: "#1B7F4B",
    successBg: "#E3F4EA",
} as const;

export const PRESENT_GRADIENT =
    "linear-gradient(90deg, #FA2F5C 0%, #CA58EF 50%, #7FB2F2 100%)";

/** The keyboard focus ring used on every Present Mode control. */
export const presentFocusRing = css`
    &:focus-visible {
        outline: 3px solid ${PRESENT_COLORS.accent};
        outline-offset: 2px;
    }
`;
